import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { EmptyState } from '@lyearn/molecules';
import { Stack } from '@lyearn/ui';

function SelectContentsEmptyState({ searchString }: { searchString: string }) {
  const { t } = useTranslation();

  return (
    <Stack className="h-full w-full p-24" direction="col" justifyContent="center">
      {searchString.length ? (
        <EmptyState
          className="pb-80"
          description={t('Path:NoResultsFound', { searchString })}
          title={t('Path:LearningContentNotFound')}
        />
      ) : (
        <EmptyState
          className="pb-80"
          description={t('Path:NoLearningContentDescription')}
          title={t('Path:NoLearningContent')}
        />
      )}
    </Stack>
  );
}

export default SelectContentsEmptyState;
